import React, { useEffect, useRef, useState } from 'react';
//@ts-ignore
import * as styles from './jotform.module.css';
import JotformIframe from './JotformIframe';
import loadable from '@loadable/component';
const Modal = loadable(() => import('react-modal'));
import axios from 'axios';
import CloseButton from '../Global/CloseButton';
export interface Props {
    formUrl: string;
    formStyle: 'embed' | 'popup';
    display: boolean;
    onPopUpClose?: () => void;
    params?: string;
    overrideStyle?: React.CSSProperties;
    applyStrongShadowToLightbox?: boolean;
    formHeight?: string;
    closeButtonSpacing?: string;
    applyLightboxHeightToJotform?: boolean;
}
import Cookies from 'js-cookie';

const Jotform: React.FC<Props> = ({
    formStyle = 'popup',
    formUrl,
    display,
    onPopUpClose = () => {},
    overrideStyle = {},
    applyLightboxHeightToJotform = false,
    formHeight = '',
    closeButtonSpacing = '',
    applyStrongShadowToLightbox = false,
    params,
}) => {
    let [ipDetails, setIpDetails] = React.useState('');
    let [url, setUrl] = React.useState('');
    const [promoCode, setPromocode] = useState('');

    useEffect(() => {
        if (!url || !display) return;
        document
            .querySelectorAll<HTMLIFrameElement>('iframe')
            .forEach((iframe) => {
                if (iframe.src.includes('jotform.com') && !iframe.title) {
                    iframe.title = 'Jotform';
                }
            });
    }, [url, display]);

    const getPathFromUrl = (stringUrl: string) => {
        return stringUrl.split(/[?#]/)[0];
    };

    const parseCookies = (): Record<string, string> => {
        if (typeof document === 'undefined') return {};
        return document.cookie
            .split('; ')
            .reduce((acc: Record<string, string>, current) => {
                const [name, ...value] = current.split('=');
                acc[name] = value.join('=');
                return acc;
            }, {});
    };

    const getUserGeolocationDetails = async () => {
        try {
            const resp = await axios.get(`${window.location.origin}/api`);
            setIpDetails(resp.data);
            const urlParams = new URLSearchParams(window.location.search);
            const promo = urlParams.get('mbsy');

            if (promo) {
                setPromocode(promo);
            }

            const cookie = parseCookies();

            let ireferrer = cookie['_uc_referrer'] ?? '';
            let lreferrer = cookie['_uc_last_referrer'] ?? '';
            let ilandpage = cookie['_uc_initial_landing_page'] ?? '';
            let visits = cookie['_uc_visits'] ?? '';
            let ucontent =
                cookie['_uc_utm_content'] || urlParams.get('utm_content') || '';
            let uSource =
                cookie['_uc_utm_source'] || urlParams.get('utm_source') || '';
            let uMedium =
                cookie['_uc_utm_medium'] || urlParams.get('utm_medium') || '';
            let uCampaign =
                cookie['_uc_utm_campaign'] ||
                urlParams.get('utm_campaign') ||
                '';

            const referrers = [
                'google',
                'facebook',
                'youtube',
                'bing',
                'yahoo',
                'duckduckgo',
            ];
            let marketingChannel = '';
            let leadSource = '';
            let referrer = '';

            if (uSource !== '') {
                if (
                    typeof uMedium === 'string' &&
                    uMedium.toLowerCase() === 'partner'
                ) {
                    const temp = uSource;
                    uSource = uMedium;
                    uMedium = temp;
                }
                marketingChannel = uSource;
                leadSource = uMedium;
            } else if (ireferrer !== '') {
                referrer = ireferrer;
                referrers.forEach((ref) => {
                    if (ref.includes(ireferrer)) {
                        referrer = ref;
                    }
                });
                marketingChannel = referrer;
                leadSource = ireferrer === 'direct' ? 'Direct' : 'organic';
            }

            marketingChannel = marketingChannel.substring(0, 40);
            ireferrer = ireferrer.substring(0, 255);
            lreferrer = lreferrer.substring(0, 255);
            ilandpage = ilandpage.substring(0, 255);
            leadSource = leadSource.substring(0, 37);

            const swcookie = Cookies?.get('sw') ?? '';
            const cidCookie = Cookies?.get('_ga') ?? '';
            const partnerCookieKey = Cookies?.get('growSumoPartnerKey') ?? '';
            const promoCode = Cookies?.get('promocode') ?? '';
            const gclid = Cookies?.get('gclid') || urlParams.get('gclid') || '';
            const UcUtmTerm =
                Cookies?.get('_uc_utm_term') || urlParams.get('utm_term') || '';
            const abtastykey =
                Cookies?.get('ABTasty')?.replace(/&/g, '$$') ?? '';
            var cookieValues =
                'USOURCE=' +
                uSource +
                '&leadSourceweb=' +
                leadSource +
                '&marketingChannel=' +
                marketingChannel +
                '&referrer=' +
                referrer +
                '&umedium=' +
                uMedium +
                '&ucampaign=' +
                uCampaign +
                '&ireferrer=' +
                ireferrer +
                '&lreferrer=' +
                lreferrer +
                '&ilandpage=' +
                ilandpage +
                '&visits=' +
                visits +
                '&ucontent=' +
                ucontent +
                '&ipAddress=' +
                resp.data.ip +
                '&swPage=' +
                getPathFromUrl(window.location.href) +
                '&swObject=' +
                swcookie +
                '&cid=' +
                cidCookie +
                '&partnerkey=' +
                partnerCookieKey +
                '&mbsy=' +
                promoCode +
                '&gclid=' +
                gclid +
                '&_uc_utm_term=' +
                UcUtmTerm +
                '&ABTasty=' +
                abtastykey;

            cookieValues = cookieValues.replace(/[^=&]+=(?:&|$)/g, '');
            if (formUrl.includes('?')) {
                var arr = formUrl.split('?');
                if (formUrl.length > 1 && arr[1] !== '') {
                    formUrl = formUrl + '&' + cookieValues;
                } else {
                    formUrl = formUrl + cookieValues;
                }
            } else {
                formUrl = formUrl + '?' + cookieValues;
            }
            setUrl(formUrl);
        } catch (e) {
            console.error(e);
        }
    };

    React.useEffect(() => {
        if (formUrl != '') {
            getUserGeolocationDetails();
        }
    }, []);

    return (
        <>
            {ipDetails !== '' ? (
                <div>
                    {display === true ? (
                        formStyle == 'popup' ? (
                            <Modal
                                contentLabel="Form"
                                isOpen={display}
                                onRequestClose={() => onPopUpClose()}
                                shouldCloseOnOverlayClick={true}
                                className={styles.modal}
                                overlayClassName={styles.overlayJotForm}
                                style={{ content: { ...overrideStyle } }}
                            >
                                <div>
                                    <style>
                                        {`
                                        .${styles.closeButton}+iframe {
                                        ${
                                            applyLightboxHeightToJotform
                                                ? `height: ${formHeight} !important;`
                                                : ''
                                        }
                                        border-radius: 1rem;
                                        }
                                        ${
                                            applyStrongShadowToLightbox
                                                ? `.${styles.overlayJotForm} { background-color: rgba(0, 0, 0, 0.5) !important; }`
                                                : ''
                                        }
                                    `}
                                    </style>
                                    <div
                                        className={styles.closeButton}
                                        style={
                                            closeButtonSpacing
                                                ? {
                                                      left: `calc(95% - ${closeButtonSpacing})`,
                                                  }
                                                : {}
                                        }
                                    >
                                        <CloseButton
                                            visualStyle="orange"
                                            onClick={() => onPopUpClose()}
                                        />
                                    </div>

                                    <JotformIframe src={url} />
                                </div>
                            </Modal>
                        ) : (
                            <JotformIframe src={url} />
                        )
                    ) : (
                        <></>
                    )}
                </div>
            ) : (
                <></>
            )}
        </>
    );
};

export default Jotform;
